import { gql } from '@apollo/client';
import { getApolloClient } from '../apolloClient';
import { updateRegistration } from '../graphql/mutations';
import { UpdateRegistrationInput } from '../API';

export type UpdateRegistrationResponse = {
  registrationId: string;
  eventId: string;
  email?: string | null;
  crmId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  registrationStatus?: string | null;
  live?: boolean | null;
  guests?: number | null;
  additionalData?: string | null;
  checkedInCount: number | null;
  __typename: string;
};

export async function updateRegistrationDetails(input: UpdateRegistrationInput): Promise<UpdateRegistrationResponse> {
  console.log('updateRegistration input: ', input);
  try {
    const client = await getApolloClient(); // Ensures client is initialized
    const { data, errors } = await client.mutate<{ updateRegistration: UpdateRegistrationResponse }>({
      mutation: gql`${updateRegistration}`,
      variables: { input },
    });

    if (errors) {
      console.error('GraphQL errors:', errors);
      throw new Error('GraphQL errors occurred');
    }
    if (!data || !data.updateRegistration) {
      throw new Error('No data returned from mutation');
    }

    return data.updateRegistration;
  } catch (err) {
    console.error('Error updating registration:', err);
    throw err;
  }
}